<template>
  <div class="wa-float-wrap">
    <!-- Tooltip -->
    <transition name="tooltip">
      <div v-if="showTooltip" class="wa-tooltip">
        تحدث معنا الآن! 👋
        <button class="close-tip" @click="showTooltip = false">×</button>
      </div>
    </transition>

    <!-- Button -->
    <a
      :href="'https://wa.me/' + phone"
      target="_blank"
      class="wa-float"
      @mouseenter="hovered = true"
      @mouseleave="hovered = false"
      aria-label="WhatsApp"
    >
      <div class="wa-pulse" />
      <svg width="28" height="28" viewBox="0 0 24 24" fill="white">
        <path
          d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347z"
        />
        <path
          d="M12 0C5.373 0 0 5.373 0 12c0 2.124.558 4.122 1.525 5.858L.057 23.392l5.747-1.504A11.944 11.944 0 0012 24c6.627 0 12-5.373 12-12S18.627 0 12 0zm0 21.818a9.818 9.818 0 01-5.017-1.374l-.36-.213-3.411.893.909-3.318-.234-.375A9.818 9.818 0 0112 2.182c5.428 0 9.818 4.39 9.818 9.818 0 5.429-4.39 9.818-9.818 9.818z"
        />
      </svg>
    </a>
  </div>
</template>

<script setup>
import { ref, onMounted } from "vue";

const phone = "201064665780";

const showTooltip = ref(false);
const hovered = ref(false);

onMounted(() => {
  // Show tooltip after 4 seconds
  setTimeout(() => {
    showTooltip.value = true;
  }, 4000);
  // Auto-hide after 8 seconds
  setTimeout(() => {
    showTooltip.value = false;
  }, 12000);
});
</script>

<style scoped>
.wa-float-wrap {
  position: fixed;
  bottom: 2rem;
  left: 2rem; /* يسار الشاشة */
  z-index: 9999;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 0.6rem;
}

.wa-float {
  width: 58px;
  height: 58px;
  background: linear-gradient(135deg, #25d366, #128c7e);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 6px 24px rgba(37, 211, 102, 0.45);
  transition: all 0.3s;
  position: relative;
}

.wa-float:hover {
  transform: scale(1.1);
  box-shadow: 0 10px 36px rgba(37, 211, 102, 0.6);
}

/* Pulse ring */
.wa-pulse {
  position: absolute;
  inset: -4px;
  border-radius: 50%;
  border: 2px solid rgba(37, 211, 102, 0.5);
  animation: wa-pulse 2s ease-out infinite;
}

@keyframes wa-pulse {
  0% {
    transform: scale(1);
    opacity: 0.8;
  }
  100% {
    transform: scale(1.6);
    opacity: 0;
  }
}

/* Tooltip */
.wa-tooltip {
  background: #fff;
  color: #1a1a1a;
  padding: 0.6rem 1rem;
  border-radius: 10px;
  font-size: 0.88rem;
  font-weight: 600;
  font-family: "Cairo", sans-serif;
  white-space: nowrap;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.15);
  display: flex;
  align-items: center;
  gap: 0.5rem;
  position: relative;
}

.wa-tooltip::after {
  content: "";
  position: absolute;
  bottom: -6px;
  left: 20px;
  width: 12px;
  height: 12px;
  background: #fff;
  transform: rotate(45deg);
  box-shadow: 2px 2px 4px rgba(0, 0, 0, 0.1);
}

.close-tip {
  background: none;
  border: none;
  font-size: 1rem;
  cursor: pointer;
  color: #999;
  line-height: 1;
  padding: 0;
}

.close-tip:hover {
  color: #333;
}

/* Transitions */
.tooltip-enter-active,
.tooltip-leave-active {
  transition: all 0.3s ease;
}
.tooltip-enter-from,
.tooltip-leave-to {
  opacity: 0;
  transform: translateY(8px);
}
</style>
